import { DateTime } from "luxon";
import { ITroubledCustomer } from "../../interfaces/TroubledCustomers";

export const sortByEventTime = (data: ITroubledCustomer[], sortBy: "ASCENDING" | "DESCENDING"): ITroubledCustomer[] => {
  return data.sort((a, b) => {
    const dateA = DateTime.fromISO(a.eventDate);
    const dateB = DateTime.fromISO(b.eventDate);
    
    if (sortBy === "ASCENDING") {
      return dateA.toMillis() - dateB.toMillis();
    } else {
      return dateB.toMillis() - dateA.toMillis();
    }
  });
}; 